/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Utility functions for localStorage
  function getLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Error getting localStorage item:', error);
      return null;
    }
  }

  function setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.error('Error setting localStorage item:', error);
      return false;
    }
  }

  // Make functions available globally
  window.getLocalStorage = getLocalStorage;
  window.setLocalStorage = setLocalStorage;

  window.generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              const r = Math.random() * 16 | 0;
              const v = c === 'x' ? r : (r & 0x3 | 0x8);
              return v.toString(16);
            });
  }

  window.fetchKitOrBundleProducts = async () => {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const kitOrBundleProducts = cart.items?.some(item => item.properties._is_tasting_kit_bundle);
    if(kitOrBundleProducts) {
      console.log('in cart model1');
      const clearAllCartItemsModal = document.querySelector("#open-clear-all-cart-items");
      // clearAllCartItemsModal.classList.add("is-open");
      if(clearAllCartItemsModal) {
        window.activateCartClearModal();
      }
    } else {
      window.allowAtc = true;
     window.triggerEl?.dispatchEvent(new Event('click'));
    }
  }

  window.activateCartClearModal = () => {
    const clearAllCartItemsModal = document.querySelector("#open-clear-all-cart-items");
    console.log('in cart model');
    if(clearAllCartItemsModal) {
      clearAllCartItemsModal.classList.add("is-open");
      const cancelClearCartButton = clearAllCartItemsModal.querySelectorAll("[data-cancel-clear-cart]");
      const continueClearCartButton = clearAllCartItemsModal.querySelectorAll("[data-continue-clear-cart]");
      cancelClearCartButton.forEach(button => {
        button.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();  
          clearAllCartItemsModal.classList.remove("is-open");
          window.allowAtc = undefined;
          window.triggerEl?.classList.remove('loading');
          window.triggerEl?.removeAttribute('disabled');
        });
      });
      continueClearCartButton.forEach(button => {
        button.addEventListener("click", async function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();  
          clearAllCartItemsModal.classList.remove("is-open");
          await fetch('/cart/clear.js');
          window.allowAtc = true;
          window.triggerEl?.dispatchEvent(new Event('click'));
        });
      });
    }
  }

  window.disableCartDrawer = (disable) => {
    const cartDrawer = document.querySelector('.cart__drawer .drawer__content');
    if(disable) {
      cartDrawer.querySelector('.drawer__body').classList.add('disabled');
      cartDrawer.querySelector('.drawer__bottom').classList.add('disabled');
    } else {
      cartDrawer.querySelector('.drawer__body').classList.remove('disabled');
      cartDrawer.querySelector('.drawer__bottom').classList.remove('disabled');
    }
  }

  window.clearAllDiscounts = async () => {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    });
    const cart = await res.json();
    return cart;
  }

  document.addEventListener("DOMContentLoaded", async function(e) {

    const applicableDiscount = parseInt(getLocalStorage('applicableDiscount'));
    if(applicableDiscount) {
      const cartItemsResponse = await fetch('/cart.js');
      const cartItemsJson = await cartItemsResponse.json();
      const hasBundle = cartItemsJson.items?.some(item => item.properties._bundleMatchUniqueId);
      if(!hasBundle) { 
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount: '' })
        });
      }
    }

    // custom model triggers
    const allModelTriggers = document.querySelectorAll("[data-custom-trigger-open-model][data-micromodal-trigger]");
    allModelTriggers.forEach(function(trigger) {
      trigger.addEventListener("click", function(e) {
        // Set z-index of other elements to 1
        document.querySelectorAll('.section--image').forEach(el => {
          el.style.zIndex = '1';
        });
        
        const modalId = trigger.getAttribute("data-micromodal-trigger");
        MicroModal.show(modalId, {
          disableScroll: false,
          disableFocus: true,
        });
      });
    });

    // custom model close triggers
    const allModelCloseTriggers = document.querySelectorAll("[data-micromodal-close]");
    allModelCloseTriggers.forEach(function(trigger) {
      trigger.addEventListener("click", function(e) {
        const modal = trigger.closest(".modal");
        modal.classList.remove("is-open");
      });
    });

    // read more toggle
    if(document.querySelectorAll('[data-readmore-toggle]').length > 0) {
			document.querySelectorAll('[data-readmore-toggle]').forEach(function(readmoreToggle) {
				readmoreToggle.addEventListener('click', function(event) {
					event.stopImmediatePropagation();
					const shortText = readmoreToggle.closest('[data-reamore-short-text]');
					const fullText = readmoreToggle.closest('.readmore-wrapper')?.querySelector('[data-reamore-full-text]');
					if(shortText && fullText) {
						shortText.style.display = 'none';
						fullText.style.display = 'block';
					}
				});
			});
		}

    // image hover script
    const imgTextBlocksSection = document.querySelectorAll('[data-img-text-blocks-section]');
    if(imgTextBlocksSection.length > 0) {
      imgTextBlocksSection.forEach(function(section) {
        const iconsBlocks = section.querySelectorAll('[data-hover-content]');
        const hoverImages = section.querySelectorAll('[data-hover-image]');
        const mainLeftWrapper = section.querySelector('[data-main-left-wrapper]');

        if(iconsBlocks.length > 0) {
          iconsBlocks.forEach(function(iconBlock) {
            const handleEvent = () => {
              const hoverContentIndex = iconBlock?.getAttribute('data-hover-content');
              const hoverImage = section.querySelector(`[data-hover-image="${hoverContentIndex}"]`);
              hoverImages?.forEach(img => img.classList.add('d-none'));
              if(hoverImage) {
                if(hoverImage) hoverImage.classList.remove('d-none');
                if(mainLeftWrapper) mainLeftWrapper.classList.add('d-none');
              } else {
                if(mainLeftWrapper) mainLeftWrapper.classList.remove('d-none');
              }
            };

            iconBlock.addEventListener('mouseenter', handleEvent);
            iconBlock.addEventListener('touchstart', handleEvent);
            iconBlock.addEventListener('click', handleEvent);
          });
        }
      });
    }
  });
})();
